/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для категории с возможностью установить таймеры для верхних баннеров
   */
  app.CategoryCountdownView = app.View.extend({
    additionalOptions: ['jsModel'],
    /**
     * @inheritDoc
     */
    run: function () {
      this.childViews.countdowns = [];
      this.template = app.helpers.TemplateHelper.getTemplate('#countdown-template');
      var countdownBanners = $('#even-bigger-chponki-category .chponck-item');
      countdownBanners.map(function (key, banner) {
        var $banner = $(banner),
          date = $banner.data('chponck-expiration'),
          id = $banner.data('chponck-id');
        if (date) {
          this.initCountdown($banner, date, id);
        }
      }.bind(this));
    },

    /**
     * Инициализация таймера
     * @param {jQuery} countdownBanner Баннер, на который устанавливается таймер
     * @param {string} date Дата окончания таймера
     * @param {number} id Идентификатор баннера
     */
    initCountdown: function (countdownBanner, date, id) {
      var countdownBlock = $('<div class="countdown-block js-countdown-block" data-id="'+ id +'"></div>');
      if (this.jsModel === 'category-sport-nutrition') {
        countdownBlock.addClass('promo-countdown-block');
      }
      countdownBanner.append(countdownBlock);

      var expiration = moment(date).valueOf();
      var currentTime = Date.now();
      var expirationPeriod = expiration - currentTime;

      this.childViews.countdowns.push(new app.CountdownView({
        el: $('.js-countdown-block[data-id="'+ id +'"]'),
        expirationPeriod: (expirationPeriod > 0) ? expirationPeriod : 0,
        template: this.template,
        inSeconds: true,
      }));
    },
  });
})(jQuery);

}.call(window));